<template>
  <div>
    <p class="form-label">{{ label }}</p>
    <div
      class="flex-column avatar avatar-huge border border-4 border-card shadow rounded d-flex align-items-center justify-content-center bg-primary-soft mb-4"
    >
      <template v-if="logo">
        <img :src="logo" class="avatar-img rounded" />
      </template>
      <template v-else>
        <i class="fa-solid fa-image fa-2xl text-primary"></i>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: "Logo",
    },
  },
};
</script>
<style scoped>
.avatar-huge {
  width: 12rem;
  height: 12rem;
}
</style>
